<template>
  <validation-observer
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      v-if="isDefaultPartner || hasPartnerOptions || isLeadgen || isAffiliates"
      id="direct-marketing-options"
      :no-validity="!hasValidation"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <!-- DIRECT MARKETING | QUOTEZONE -->
      <template v-if="isDefaultPartner || isAffiliates">
        <!-- DIRECT MARKETING TEXT -->
        <marketing-text
          :title="marketingText.title"
          :subtitle="marketingText.subtitle"
        />

        <direct-marketing-option
          :options-value="questionData"
          @change-option="changeOption"
        />
      </template>

      <!-- PARTNER MARKETING | WL -->
      <template v-if="hasPartnerOptions">
        <!-- PARTNER MARKETING TEXT -->
        <marketing-text
          :title="partnerMarketingText.title"
          :subtitle="partnerMarketingText.subtitle"
        />

        <partner-marketing-options
          :step-id="stepId"
          :options-value="questionData"
          :single-option="partnerSingleOption"
          @change-option="changeOption"
        />

        <!-- PRIVACY POLICY TEXT -->
        <marketing-text
          :subtitle="privacyPolicy"
        />
      </template>

      <!-- LG's TERMS AND CONDITIONS -->
      <template v-if="isLeadgen">
        <v-divider
          class="mt-5 pb-5"
        />

        <lg-terms-and-conditions />
      </template>
    </form-section>
  </validation-observer>
</template>

<script>

import QuestionBase from './Base';
import PartnerMarketingOptions from '@/components/marketingOptions/PartnerMarketingOptions';
import DirectMarketingOption from '@/components/marketingOptions/DirectMarketingOption';
import MarketingText from '@/components/marketingOptions/MarketingText.vue';
import LgTermsAndConditions from '@/views/LG/components/LgTermsAndConditions.vue';

export default {
  name: 'question-direct-marketing-options',
  components: {
    DirectMarketingOption,
    PartnerMarketingOptions,
    LgTermsAndConditions,
    MarketingText,
  },
  inject: ['isLeadgen', 'constants', 'config'],
  extends: QuestionBase,
  data () {
    return {
      fields: [],
    };
  },
  computed: {
    isDefaultPartner () {
      // Compare Ni treated as a default partner in this case
      return this.constants.PARTNERS.CompareNI.includes(this.config.partner) ||
      this.constants.PARTNERS.Tiger.includes(this.config.partner) ||
      [this.constants.DEFAULT_PARTNER, this.constants.DEFAULT_PARTNER_ALTERNATIVE].includes(this.config.partner);
    },
    isAffiliates () {
      return this.config.brandingType === this.constants.QUOTEZONE_AFFILIATE;
    },
    hasPartnerOptions () {
      return this.config.partnerMarketingOptions?.length > 0;
    },
    partnerSingleOption () {
      if (this.config.partnerMarketingOptions?.length === 1) {
        return this.constants.PARTNER_MARKETING_OPTIONS[this.config.partnerMarketingOptions[0]];
      }
      return null;
    },
    hasValidation () {
      return this.hasPartnerOptions && !!this.partnerSingleOption;
    },
    marketingText () {
      return { ...this.config.marketingText };
    },
    partnerMarketingText () {
      return { ...this.config.partnerMarketingText };
    },
    privacyPolicy () {
      return this.config.partnerPrivacyPolicyText?.subtitle;
    },
  },
  created () {
    const type = this.isDefaultPartner ? 'direct' : 'partner';
    // for LGs get data from sessionData, because stepData don't have appropriate keys
    const data = this.isLeadgen ? this.sessionData : this.stepData;

    const fields = this.isDefaultPartner && this.isLeadgen ? [`${type}MarketingEmail`]
      : [`${type}MarketingEmail`, `${type}MarketingSms`, `${type}MarketingPost`, `${type}MarketingPhone`];

    this.$set(this, 'fields', fields);

    this.fields.forEach((field) => {
      const val = this.getQuestionFieldValue(data, field);

      this.$set(this.questionData, field, val);
    });
  },
  methods: {
    changeOption ({ fields, option, value }) {
      // We only want to change the fields which are relevant
      if (fields) {
        fields.forEach(field => {
          this.questionData[field] = value;
        });

        return;
      }

      this.questionData[option] = value;
    },
    getQuestionFieldValue (data, field) {
      // even if partner have only single option for marketing we still need send all of them to support old systems and sids
      // point to refactor on BE side and remove redundant fields from FE payload
      const isSingleOptionField = this.partnerSingleOption?.field === field;

      // if new user - set false to fields (null for single marketing option so the radio buttons wont be prepopulated)
      // otherwise - set session value
      const stepDataHasField = Object.prototype.hasOwnProperty.call(data, field);

      if (stepDataHasField && data[field] !== null) return !!data[field];

      if (!isSingleOptionField) return false;

      return null;
    },
  },
};
</script>
